import type { DemoKey } from '../types';

export const id: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matematika · Statistika',
  'app.title': 'Statistika',
  'panel.experiment': 'Adegan',
  'panel.params': 'Parameter',

  'exp.survey-explorer.title': 'Penjelajah survei',
  'exp.survey-explorer.desc': 'Pilih kolom; demo memilih ringkasan yang sesuai.',
  'exp.distribution-sculptor.title': 'Pemahat distribusi',
  'exp.distribution-sculptor.desc': 'Seret titik dan lihat reaksi statistik.',
  'exp.two-variable-lab.title': 'Lab dua variabel',
  'exp.two-variable-lab.desc': 'Sebaran, kecocokan, dan pertanyaan sebab-akibat.',
  'exp.sampling-lab.title': 'Lab penyampelan',
  'exp.sampling-lab.desc': 'Bagaimana teknik dan ukuran menggerakkan rerata sampel.',
  'exp.probability-diagrams.title': 'Diagram peluang',
  'exp.probability-diagrams.desc': 'Tampilan Venn dan pohon untuk peristiwa majemuk.',

  'type.qualitative-nominal.label': 'Kualitatif · nominal',
  'type.qualitative-nominal.def': 'Kategori tanpa urutan bawaan.',
  'type.qualitative-ordinal.label': 'Kualitatif · ordinal',
  'type.qualitative-ordinal.def': 'Kategori dengan urutan bermakna.',
  'type.qualitative-multi.label': 'Kualitatif · multi-nilai',
  'type.qualitative-multi.def': 'Setiap pengamatan bisa punya beberapa label.',
  'type.quantitative-discrete.label': 'Kuantitatif · diskret',
  'type.quantitative-discrete.def': 'Angka dengan langkah tetap.',
  'type.quantitative-continuous.label': 'Kuantitatif · kontinu',
  'type.quantitative-continuous.def': 'Angka pada skala kontinu.',

  'column.name.label': 'Nama siswa',
  'column.height_cm.label': 'Tinggi',
  'column.shoe_size_eu.label': 'Ukuran sepatu (EU)',
  'column.study_hours.label': 'Jam belajar / minggu',
  'column.test_score.label': 'Nilai tes',
  'column.sports_played.label': 'Olahraga yang dimainkan',
  'column.eye_color.label': 'Warna mata',
  'column.commute_min.label': 'Perjalanan',
  'column.grade_year.label': 'Kelas',
  'column.homework_effort.label': 'Usaha PR',
  'column.ice-cream-sales.label': 'Penjualan es krim',
  'column.drownings.label': 'Tenggelam',
  'column.month.label': 'Bulan',
  'column.storks.label': 'Bangau',
  'column.births.label': 'Kelahiran',
  'column.country_area_km2.label': 'Luas negara',
  'column.sleep_hours.label': 'Jam tidur',
  'column.reaction_ms.label': 'Waktu reaksi',

  'dataset.master-survey.label': 'Survei kelas',
  'dataset.master-survey.desc': '30 siswa simulasi.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Penjualan es krim vs tenggelam',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Keduanya naik turun mengikuti musim. Tenggelam tidak menyebabkan penjualan es krim.',
  'dataset.spurious-storks-vs-births.label': 'Bangau vs kelahiran',
  'dataset.spurious-storks-vs-births.desc':
    'Negara lebih besar punya lebih banyak bangau dan kelahiran. Burung bukan penyebabnya.',
  'dataset.real-sleep-vs-reaction-time.label': 'Tidur vs waktu reaksi',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Lebih banyak tidur, reaksi lebih cepat. Korelasi negatif nyata — dengan mekanisme masuk akal.',

  'tag.football.label': 'Sepak bola',
  'tag.basketball.label': 'Bola basket',
  'tag.volleyball.label': 'Bola voli',
  'tag.swimming.label': 'Renang',
  'tag.none.label': 'Tidak ada',

  'population.gaussian.label': 'Kurva lonceng',
  'population.right-skewed.label': 'Miring ke kanan',
  'population.bimodal.label': 'Bimodal (berstrata)',
  'population.uniform.label': 'Seragam',

  'venn.dice-even-or-prime.label': 'Dadu: genap atau prima',
  'venn.class-sports-2set.label': 'Olahraga (2 himpunan)',
  'venn.class-sports-3set.label': 'Olahraga (3 himpunan)',
  'venn.custom.label': 'Kustom',

  'tree.draw-without-replacement.label': 'Ambil tanpa pengembalian',
  'tree.custom.label': 'Kustom',
  'tree.coin.heads': 'A',
  'tree.coin.tails': 'G',
  'tree.draw.start': 'Kantong: 2 merah, 3 biru',
  'tree.draw.red': 'Merah',
  'tree.draw.blue': 'Biru',
  'tree.custom.start': 'Mulai',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogram',
  'card.cumulative': 'Frekuensi kumulatif',
  'card.box': 'Box plot',
  'card.summary': 'Ringkasan 5-angka',
  'card.bar': 'Diagram batang',
  'card.mode': 'Modus',
  'card.tag-frequency': 'Frekuensi label',
  'card.mode-tag': 'Label dominan',
  'card.empty-no-order': 'Tidak berlaku',
  'card.empty-multi': 'Tidak berlaku',
  'card.numberline': 'Garis bilangan',
  'card.scatter': 'Sebaran',
  'card.description': 'Apa yang terjadi',
  'card.population': 'Populasi',
  'card.sampling-distribution': 'Rerata sampel',
  'card.venn': 'Venn',
  'card.tree': 'Pohon',
  'card.probabilities': 'Peluang',

  'param.dataset.label': 'Kumpulan data',
  'param.column.label': 'Kolom',
  'param.bins.label': 'Bin',
  'param.shape.label': 'Bentuk awal',
  'param.show-mean.label': 'Tampilkan rerata',
  'param.show-median.label': 'Tampilkan median',
  'param.x-col.label': 'Kolom X',
  'param.y-col.label': 'Kolom Y',
  'param.show-regression.label': 'Garis regresi',
  'param.show-residuals.label': 'Residu',
  'param.show-confounder.label': 'Tampilkan confounder',
  'param.population.label': 'Populasi',
  'param.technique.label': 'Teknik',
  'param.sample-size.label': 'Ukuran sampel',
  'param.stratum.label': 'Strata',
  'param.bias.label': 'Bias',
  'param.mode.label': 'Mode',
  'param.preset.label': 'Preset',
  'param.universe.label': 'Ukuran semesta',
  'param.show-prob.label': 'Tampilkan peluang',
  'param.treat-as-numeric.label': 'Anggap numerik',

  'stat.count': 'Banyak',
  'stat.mean': 'Rerata',
  'stat.median': 'Median',
  'stat.range': 'Jangkauan',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Pencilan',
  'stat.r': 'r Pearson',
  'stat.r2': 'r²',
  'stat.slope': 'Kemiringan',
  'stat.intercept': 'Konstanta',
  'stat.n': 'n',
  'stat.population-mean': 'Rerata sejati',
  'stat.latest-sample-mean': 'Rerata sampel',
  'stat.sample-mean-spread': 'SD rerata sampel',
  'stat.sample-count': 'Sampel diambil',
  'outlier.upper': 'Pencilan atas',
  'outlier.lower': 'Pencilan bawah',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Ulangi sampel',
  'btn.run-100': 'Ambil 100 sampel',
  'btn.stop': 'Berhenti',
  'btn.clear-history': 'Hapus riwayat',

  'explainer.no-order': 'Tanpa urutan → tanpa kumulatif, tanpa kotak.',
  'explainer.multi-no-iqr': 'Multi-nilai → kuartil / IQR tak terdefinisi.',
  'message.no-data': 'Tidak ada data.',
  'message.needs-quartiles': 'Perlu ≥4 titik untuk kuartil.',
  'message.x-zero-variance': 'Varians X nol — tak ada garis untuk pas.',
  'message.n-too-small': 'n terlalu kecil.',
  'message.stratum-clamp': 'Strata punya baris lebih sedikit — semuanya dipakai.',
  'message.siblings-sum-to-one': 'Saudara harus berjumlah 1.',
};
